import { tv } from "tailwind-variants";

export const getCheckboxClass = tv({
  base: "peer size-4 shrink-0 rounded-xs border border-primary shadow-xs focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground",
});
